import BaseComponent from "../BaseComponent";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";

const AppearanceComponent = ({selectedObject, inputOnChange}) => {
  const {type, material} = selectedObject;
  const assetOpacity = selectedObject.userData.opacity;

  return (
    <BaseComponent title="Appearance" foldable={true}>
      {type === "Group" && (
        <NumberSliderInput
          name="Transparency"
          value={parseInt(assetOpacity * 100)}
          min={0}
          max={100}
          step={1}
          inputOnChange={inputOnChange}
        />
      )}
      {type === "Sprite" && (
        <NumberSliderInput
          name="Transparency"
          value={parseInt(material.opacity * 100)}
          min={0}
          max={100}
          step={1}
          inputOnChange={inputOnChange}
        />
      )}
    </BaseComponent>
  );
};

export default AppearanceComponent;
